import React from 'react';

const TermsConditionsES: React.FC = () => {
  return (
    <div className="prose max-w-none">
      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-gray-800 mb-4">1. Aceptación de los Términos</h2>
        <p className="mb-4">
          Al descargar, instalar o usar la aplicación móvil y sitio web de GatherPlay (el "Servicio"), aceptas estar 
          sujeto a estos Términos y Condiciones ("Términos"). Si no estás de acuerdo con estos Términos, no uses el Servicio.
        </p>
        <div className="bg-gray-100 p-4 rounded-lg mb-4">
          <p><strong>Proveedor del Servicio:</strong></p>
          <ul className="list-none mt-2 space-y-1">
            <li>Empresa: BIXMO SRL</li>
            <li>Dirección: Chisinau, Moldavia</li>
            <li>Correo: gatherplay.application@gmail.com</li>
          </ul>
        </div>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-gray-800 mb-4">2. Descripción del Servicio</h2>
        <p className="mb-4">
          GatherPlay es un juego multijugador donde los jugadores actúan escenarios basados en niveles de intensidad numerados 
          mientras un jugador trata de adivinar quién tiene qué número. El Servicio incluye:
        </p>
        <ul className="list-disc pl-6 space-y-1">
          <li>Aplicación móvil para dispositivos iOS y Android</li>
          <li>Aplicación web accesible a través de navegadores</li>
          <li>Funcionalidad de juego multijugador</li>
          <li>Contenido de cartas de escenarios</li>
        </ul>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-gray-800 mb-4">3. Requisitos de Edad</h2>
        <p>
          GatherPlay está destinado para usuarios de 6 años en adelante. Los usuarios menores de 13 años deben usar el Servicio 
          bajo supervisión parental. Al usar el Servicio, declaras que cumples con los requisitos de edad.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-gray-800 mb-4">4. Conducta del Usuario</h2>
        <p className="mb-4">Aceptas usar el Servicio responsablemente y aceptas NO:</p>
        <ul className="list-disc pl-6 space-y-1">
          <li>Usar el Servicio para cualquier propósito ilegal o en violación de cualquier ley local, estatal, nacional o internacional</li>
          <li>Acosar, abusar o dañar a otros jugadores</li>
          <li>Intentar hacer ingeniería inversa, modificar o hackear la aplicación</li>
          <li>Usar scripts automatizados o bots para interactuar con el Servicio</li>
          <li>Compartir contenido inapropiado durante el juego</li>
          <li>Interferir con o interrumpir el Servicio o los servidores</li>
        </ul>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-gray-800 mb-4">5. Derechos de Propiedad Intelectual</h2>
        
        <h3 className="text-xl font-semibold text-gray-700 mb-3">5.1 Nuestro Contenido</h3>
        <p className="mb-4">Todo el contenido en GatherPlay, incluyendo pero no limitado a:</p>
        <ul className="list-disc pl-6 mb-4 space-y-1">
          <li>Mecánicas y reglas del juego</li>
          <li>Cartas de escenarios y contenido del juego</li>
          <li>Código de software y algoritmos</li>
          <li>Gráficos, logotipos y elementos de diseño</li>
          <li>Texto y materiales escritos</li>
        </ul>
        <p className="mb-4">es propiedad de BIXMO SRL y está protegido por derechos de autor, marcas registradas y otras leyes de propiedad intelectual.</p>

        <h3 className="text-xl font-semibold text-gray-700 mb-3">5.2 Tu Licencia</h3>
        <p>
          Te otorgamos una licencia limitada, no exclusiva, no transferible para usar el Servicio para fines personales, 
          no comerciales de acuerdo con estos Términos.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-gray-800 mb-4">6. Funciones Premium y Pagos</h2>
        
        <h3 className="text-xl font-semibold text-gray-700 mb-3">6.1 Compra Dentro de la Aplicación</h3>
        <p className="mb-4">
          GatherPlay ofrece una actualización premium disponible a través de compra dentro de la aplicación que elimina 
          los anuncios. Esta es una compra única vinculada a tu cuenta de la tienda de aplicaciones.
        </p>

        <h3 className="text-xl font-semibold text-gray-700 mb-3">6.2 Reembolsos</h3>
        <p className="mb-4">
          Las políticas de reembolso están regidas por las respectivas políticas de la tienda de aplicaciones (Apple App Store 
          o Google Play Store). No procesamos reembolsos directamente.
        </p>

        <h3 className="text-xl font-semibold text-gray-700 mb-3">6.3 Cambios de Precio</h3>
        <p>
          Nos reservamos el derecho de cambiar el precio de las funciones premium en cualquier momento, aunque los cambios 
          no afectarán las compras existentes.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-gray-800 mb-4">7. Publicidad</h2>
        <p>
          La versión gratuita de GatherPlay muestra anuncios. Al usar la versión gratuita, consientes ver estos anuncios. 
          Los anuncios son proporcionados por redes de terceros y no somos responsables de su contenido.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-gray-800 mb-4">8. Datos y Privacidad</h2>
        <p>
          Tu privacidad es importante para nosotros. Por favor revisa nuestra Política de Privacidad, que explica cómo 
          recopilamos, usamos y protegemos tu información. La Política de Privacidad se incorpora a estos Términos por referencia.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-gray-800 mb-4">9. Disponibilidad del Servicio</h2>
        
        <h3 className="text-xl font-semibold text-gray-700 mb-3">9.1 Disponibilidad</h3>
        <p className="mb-4">
          Nos esforzamos por mantener el Servicio disponible 24/7, pero no garantizamos acceso ininterrumpido. El Servicio 
          puede estar temporalmente no disponible debido a:
        </p>
        <ul className="list-disc pl-6 mb-4 space-y-1">
          <li>Mantenimiento programado</li>
          <li>Dificultades técnicas</li>
          <li>Factores fuera de nuestro control</li>
        </ul>

        <h3 className="text-xl font-semibold text-gray-700 mb-3">9.2 Actualizaciones</h3>
        <p>
          Podemos actualizar el Servicio de vez en cuando para agregar funciones, corregir errores o mejorar el rendimiento. 
          Algunas actualizaciones pueden ser requeridas para el uso continuo del Servicio.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-gray-800 mb-4">10. Limitación de Responsabilidad</h2>
        <p className="mb-4">En la máxima medida permitida por la ley aplicable:</p>
        <ul className="list-disc pl-6 space-y-1">
          <li>El Servicio se proporciona "tal como es" sin garantías de ningún tipo</li>
          <li>No somos responsables de ningún daño indirecto, incidental, especial o consecuente</li>
          <li>Nuestra responsabilidad total no excederá la cantidad que pagaste por las funciones premium (si las hay)</li>
          <li>No somos responsables de ninguna pérdida de datos o interrupción del servicio</li>
        </ul>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-gray-800 mb-4">11. Indemnización</h2>
        <p>
          Aceptas indemnizar y mantener indemne a BIXMO SRL de cualquier reclamo, daño o gasto que surja de tu uso del 
          Servicio o violación de estos Términos.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-gray-800 mb-4">12. Terminación</h2>
        
        <h3 className="text-xl font-semibold text-gray-700 mb-3">12.1 Terminación por Ti</h3>
        <p className="mb-4">Puedes dejar de usar el Servicio en cualquier momento desinstalando la aplicación.</p>

        <h3 className="text-xl font-semibold text-gray-700 mb-3">12.2 Terminación por Nosotros</h3>
        <p className="mb-4">
          Podemos terminar o suspender tu acceso al Servicio en cualquier momento, con o sin causa, con o sin aviso.
        </p>

        <h3 className="text-xl font-semibold text-gray-700 mb-3">12.3 Efecto de la Terminación</h3>
        <p>
          Al terminar, tu derecho a usar el Servicio cesa inmediatamente. Las disposiciones que deben sobrevivir la terminación 
          (incluyendo derechos de propiedad intelectual, limitación de responsabilidad e indemnización) continuarán aplicándose.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-gray-800 mb-4">13. Ley Aplicable</h2>
        <p>
          Estos Términos se rigen y se interpretan de acuerdo con las leyes de la República de Moldavia, sin consideración 
          a sus disposiciones de conflicto de leyes.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-gray-800 mb-4">14. Resolución de Disputas</h2>
        <p>
          Cualquier disputa que surja de estos Términos o del uso del Servicio se resolverá a través de arbitraje vinculante 
          de acuerdo con las leyes de la República de Moldavia, o en los tribunales competentes de Chisinau, Moldavia.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-gray-800 mb-4">15. Cambios a los Términos</h2>
        <p className="mb-4">Nos reservamos el derecho de modificar estos Términos en cualquier momento. Notificaremos a los usuarios de cambios materiales mediante:</p>
        <ul className="list-disc pl-6 mb-4 space-y-1">
          <li>Publicar Términos actualizados dentro de la aplicación</li>
          <li>Actualizar la fecha de "Última Actualización"</li>
          <li>Proporcionar notificación en la aplicación para cambios significativos</li>
        </ul>
        <p>El uso continuo del Servicio después de los cambios constituye aceptación de los Términos actualizados.</p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-gray-800 mb-4">16. Divisibilidad</h2>
        <p>
          Si se encuentra que alguna disposición de estos Términos es inaplicable, el resto de los Términos permanecerá 
          en plena vigencia y efecto.
        </p>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-gray-800 mb-4">17. Información de Contacto</h2>
        <p className="mb-4">Para preguntas sobre estos Términos y Condiciones, contáctanos:</p>
        <ul className="list-disc pl-6 space-y-1">
          <li>Correo: gatherplay.application@gmail.com</li>
          <li>Empresa: BIXMO SRL, Chisinau, Moldavia</li>
        </ul>
      </section>

      <section className="mb-8">
        <h2 className="text-2xl font-semibold text-gray-800 mb-4">18. Acuerdo Completo</h2>
        <p>
          Estos Términos, junto con nuestra Política de Privacidad, constituyen el acuerdo completo entre tú y BIXMO SRL 
          con respecto al uso del Servicio.
        </p>
      </section>

      <div className="bg-blue-50 p-4 rounded-lg mt-8">
        <p className="text-sm text-blue-800">
          Al usar GatherPlay, reconoces que has leído, entendido y aceptas estar sujeto a estos Términos y Condiciones.
        </p>
      </div>
    </div>
  );
};

export default TermsConditionsES;